var _ellipse, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_7278",
    "data-name": "Groupe 7278",
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 18.925,
    viewBox: "0 0 4 18.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 2,
    cy: 2,
    rx: 2,
    ry: 2,
    fill: "#cbc9c9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 2,
    cy: 2,
    rx: 2,
    ry: 2,
    transform: "translate(0 7.463)",
    fill: "#cbc9c9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 2,
    cy: 2,
    rx: 2,
    ry: 2,
    transform: "translate(0 14.925)",
    fill: "#cbc9c9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOption);
export default __webpack_public_path__ + "static/media/iconOption.2f77b3bfe237c0e54fcfe2345a068c34.svg";
export { ForwardRef as ReactComponent };